export enum OfferLabels {
  Fastest = 'fastest',
  Cheapest = 'cheapest',
  Promotion = 'promotion'
}
